<template>
  <div class="grid grid-rows md:grid-cols md:grid-rows-1 md:grid-cols-2 text-pdsPrimaryColor relative">
    <div class="my-2 md:my-4 cursor-pointer" @click.prevent="selectPatient">
      <div
        v-if="computedPatientName"
        class="mb-1 flex items-center space-x-1"
        :class="{ 'pointer-events-none cursor-not-allowed': patient.IsArchived }"
      >
        <img v-if="patient.IsDeceased" :src="require('@/static/img/christianity.svg')" class="inline-block" />
        <div class="text-lg md:text-xl lg:text-xl hover:underline font-bold">
          {{ computedPatientName }}
        </div>
      </div>
      <div class="text-sm font-medium w-5/6 md:w-full">
        <span>{{ $formatDate(patient.DateOfBirth) }}</span>
        <span v-if="patient.BSN"> | {{ patient.BSN }} </span>
        <span> | {{ patient.PostalCode }}</span>
        <span v-if="patient.CustomerNumber"> | {{ patient.CustomerNumber }}</span>
      </div>
    </div>
    <div class="place-content-center space-x-2">
      <div
        class="flex justify-start md:justify-end place-content-end items-start md:items-end self-start flex-wrap flex-row"
      >
        <button
          @click.prevent="showModal"
          class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-pdsPrimaryColor border border-pdsPrimaryColor bg-white rounded-full hover:bg-primary-default/50 items-center my-2 mr-2"
        >
          <span class="">Ontvolgen</span>
        </button>
      </div>
    </div>
    <div
      class="absolute top-1/2 right-2 -translate-y-1/2 block md:hidden cursor-pointer"
      @click.prevent="selectPatient"
    >
      <ChevronRightIcon class="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
    </div>
  </div>
  <div class="border-b border-sky-200"></div>
  <generic-modal v-if="isModalVisible">
    <template #header> Patiënt ontvolgen </template>
    <template #body>
      <p>
        U staat op het punt om een patiënt te ontvolgen. Door het ontvolgen van een patiënt ontvangt u geen updates meer
        met betrekking tot zijn/haar behandeling. Weet u zeker dat u wilt doorgaan?
      </p>
    </template>
    <template #footer>
      <v-button tagelement="button" md hollow transparent @click="closeModal"> Annuleren </v-button>
      <v-button tagelement="button" md primary @click="SaveUnfollowPatient"> Patiënt toch ontvolgen </v-button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from '@/components/shared/GenericModal';
import { currentUserIdentity$ } from '@/services';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { ChevronRightIcon } from '@heroicons/vue/20/solid';
import axios from 'axios';

export default {
  components: { GenericModal, ChevronRightIcon },
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const user = ref(null);
    const isModalVisible = ref(false);

    currentUserIdentity$.subscribe((value) => {
      user.value = value;
    });

    const nameFormat = (value) => {
      if (value === 1) {
        return 'Dhr. ';
      } else if (value === 2) {
        return 'Mevr. ';
      } else {
        return '';
      }
    };

    const computedPatientName = computed(() => {
      const { GenderId, Initials, FirstName, PrePosition, LastName, IsArchived } = props.patient;

      return [nameFormat(GenderId), Initials || FirstName, PrePosition, LastName, IsArchived ? '- Inactief' : null]
        .filter(Boolean)
        .join(' ');
    });

    const showModal = () => {
      isModalVisible.value = true;
    };

    const closeModal = () => {
      isModalVisible.value = false;
    };

    const selectPatient = () => {
      emit('select', props.patient.PatientId);
    };

    const SaveUnfollowPatient = () => {
      axios.post('MyPatients/UnfollowPatient?customerId=' + props.patient.PatientId).then((response) => {
        if (response.data.Success) {
          emit('query');
        }
      });
      isModalVisible.value = false;
    };

    return {
      computedPatientName,
      user,
      isModalVisible,
      showModal,
      closeModal,
      selectPatient,
      SaveUnfollowPatient
    };
  }
};
</script>
